// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  flex: 1 0 auto; /* pour garder le footer dessous, meme avec scroll bar */
}`, "",{"version":3,"sources":["webpack://./src/app/components/redirect/redirect.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA,EAAA,wDAAA;AACF","sourcesContent":[":host {\n  flex: 1 0 auto; /* pour garder le footer dessous, meme avec scroll bar */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
